module.exports = __webpack_public_path__ + "img/graph-1b.3f17ad86.png";